function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 4C2 2.89543 2.89543 2 4 2H10C11.1046 2 12 2.89543 12 4V15.5C12 15.6844 11.8985 15.8538 11.7359 15.9408C11.5733 16.0278 11.3761 16.0183 11.2226 15.916L7 13.1009L2.77735 15.916C2.62392 16.0183 2.42665 16.0278 2.26407 15.9408C2.10149 15.8538 2 15.6844 2 15.5V4ZM4 3C3.44772 3 3 3.44772 3 4V14.5657L6.72265 12.084C6.8906 11.972 7.1094 11.972 7.27735 12.084L11 14.5657V4C11 3.44772 10.5523 3 10 3H4Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.26758 1H12C12.069 1 12.1365 1.007 12.2015 1.02032C12.6572 1.11356 13 1.51675 13 2V13.7676L13.2227 13.916C13.3761 14.0183 13.5734 14.0278 13.7359 13.9408C13.8985 13.8538 14 13.6844 14 13.5V2C14 0.89543 13.1046 0 12 0H6.00001C5.25973 0 4.61339 0.402199 4.26758 1Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4515:7388)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#0066CC"
}));

function SvgBookmarkActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4515:7388",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _ref2, _ref3), _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkActive);
export default __webpack_public_path__ + "static/media/bookmark_active.a76c93df.svg";
export { ForwardRef as ReactComponent };